// extracted by mini-css-extract-plugin
module.exports = {"BackgroundColorWhite":"Sections_BackgroundColorWhite__7Ustt","BackgroundColorGrey":"Sections_BackgroundColorGrey__20hsl","Hero":"Sections_Hero__kA_OT"};